import React from "react";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import useModal from "../../../hooks/useModal";
import { FaUserPlus } from "react-icons/fa6";
import ModalCreateLeader from "./ModalCreateLeader";

const CreateLeader = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} bgColor="green" onClick={open} width="w-10" />
            {isOpen &&
                <Modal title="Crear lider contable" onClose={close}>
                    <ModalCreateLeader onClose={close} refetch={refetch}/>
                </Modal>
            }
        </div>
    );
};

export default CreateLeader;